import React from 'react'
import { useState } from 'react'
import Store from 'redux/Store'
import { setSettings } from 'shared/redux/actions'
import { iconStyle } from 'shared/consts'
import { IonIcon } from '@ionic/react'
import  { caretBackOutline, caretForwardOutline } from 'ionicons/icons'

const MinimizeBarButton: React.FunctionComponent = () => {

    const [minimized, setMinimized] = useState<boolean>(false)
    
    const toggleMinimized = () => {
        
        const newMinimized = !minimized
        setMinimized(newMinimized)

        let newSettings = Store.getState().settings
        newSettings['minimizedBar'] = minimized
        Store.dispatch(setSettings(newSettings))
    }

    return (
        <div className='minimize-bar-button' onClick={() => {
            toggleMinimized()
            return
        }}>
            <IonIcon icon={minimized ? caretBackOutline : caretForwardOutline} className='ionicon' style={{color: iconStyle.colorActive, fontSize: '16px'}} />
        </div>
    )
}


export default MinimizeBarButton